/**
 * 基础菜单 学员管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学员管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选  accordion -->
    <el-collapse ref="coll" v-model="activeCollapseNames">
      <el-collapse-item name="search">
        <template slot="title">
          <!-- 搜索区域折叠行 -->
          <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
            <div style="display: flex; flex-wrap: nowrap; align-items: center;">
              <el-form ref="queryForm" :inline="true" :model="queryParams" class="user-search">
                <el-form-item label="搜索：">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.account" placeholder="请输入卡号"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>

        <!-- 这是折叠的内容区域 -->
        <div
          style="display: flex; flex-wrap: wrap;"
        >
          <el-form
            :model="queryParams"
            ref="queryForm2"
            :inline="true"
            label-width="68px"
          >
            <el-form-item label="" v-if="systemFlag == 1">
              <el-input size="small" v-model="queryParams.orgName" placeholder="输入客户名称"></el-input>
            </el-form-item>
            <el-form-item label="" v-if="systemFlag == 1">
              <el-cascader
                size="small"
                placeholder="选择考试科目"
                style="width: 100%"
                v-model="queryParams.subjectId"
                :options="treeOptions"
                emitPath="false"
                :props="{ emitPath:false }"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="" v-if="systemFlag == 1">
              <el-select size="small" v-model="queryParams.lx" placeholder="请选择客户类型" clearable>
                <el-option v-for="x in lxList" :label="x.dictLabel" :value="x.dictValue" :key="x.dictValue"></el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!--列表-->
    <el-table
      v-if="lx == 1 || lx == 0"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
<!--      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" :selectable="selected" />-->
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="phone" label="手机号码"/>
      <el-table-column prop="idcard" label="身份证号"/>
      <el-table-column prop="wxName" label="绑定微信号"/>
      <el-table-column prop="account" label="卡号"/>
      <el-table-column prop="password" label="密码"/>
      <el-table-column prop="subjectName" label="考试科目" width="350"/>

      <!--        <el-table-column prop="lx" label="练习情况"/>-->

      <el-table-column prop="avgScore" label="模拟情况（近五次平均分）" width="80">
        <template slot-scope="scope">
          <el-link type="primary" @click="openAvgScore(scope.row)">
            {{ scope.row.avgScore }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="kscj" label="考试成绩" width="80" v-if="lx == 0"/>
      <el-table-column prop="createTime" label="导入时间"/>
      <el-table-column align="center" label="操作" width="80" v-if="lx == 0">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="录入成绩"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleScores(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>

    <el-table
      v-if="lx == 2"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
      <!--      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" :selectable="selected" />-->
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="account" label="卡号"/>
      <el-table-column prop="password" label="密码"/>
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="phone" label="手机号码"/>
      <el-table-column prop="wxName" label="绑定微信号"/>
      <el-table-column prop="subjectName" label="考试科目" width="350"/>

      <!--        <el-table-column prop="lx" label="练习情况"/>-->

      <el-table-column prop="avgScore" label="模拟情况" width="80">
        <template slot-scope="scope">
          <el-link type="primary" @click="openAvgScore(scope.row)">
            {{ scope.row.avgScore }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="购卡时间"/>
      <el-table-column prop="validTime" label="卡到期时间"/>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 模拟情况 -->
    <el-dialog title="模拟练习分数" :visible.sync="scoreShow" width="40%" top="5vh" :close-on-click-modal="false" @click="scoreShow = false" append-to-body>
      <div style="max-height: 70vh; overflow-y: auto;">

        <el-table
          size="small"
          :data="scoreList"
          highlight-current-row
          v-loading="false"
          border
          element-loading-text="拼命加载中"
          style="width: 100%;"
          :row-key="(row) => { return row.id }"
        >
          <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
          <el-table-column prop="paperName" label="试卷名称"/>
          <el-table-column prop="avgScore" label="平均分"/>
          <el-table-column prop="paperNum" label="数量">
            <template slot-scope="scope">
              <el-link type="primary" @click="openPaper(scope.row)">
                <span>{{ scope.row.paperNum }}</span>
              </el-link>
            </template>
          </el-table-column>
        </el-table>

<!--        <div v-for="x in scoreList">
          <el-descriptions class="margin-top" :title="x.paperName" :column="4" border style="background-color: white; padding: 10px; border-radius: 5px; height: 13vh;">
            &lt;!&ndash;        <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-date"></i>
                        试卷名称
                      </template>
                      {{ x.paperName }}
                    </el-descriptions-item>&ndash;&gt;
            <el-descriptions-item>
              <template slot="label">
                总分
              </template>
              {{ x.totalScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                及格分
              </template>
              {{ x.passScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                本次得分
              </template>
              {{ x.realScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                创建时间
              </template>
              {{ x.createTime }}
            </el-descriptions-item>
          </el-descriptions>
        </div>-->
      </div>
    </el-dialog>

    <!-- 全部模拟情况 -->
    <el-dialog title="全部模拟情况" :visible.sync="paperShow" width="70%" top="5vh" :close-on-click-modal="false" @click="paperShow = false" append-to-body>
      <div style="max-height: 70vh; overflow-y: auto;">

        <el-table
          size="small"
          :data="paperList"
          highlight-current-row
          v-loading="false"
          border
          element-loading-text="拼命加载中"
          style="width: 100%;"
        >
          <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
          <el-table-column prop="paperName" label="试卷名称"/>
          <el-table-column prop="realScore" label="得分"/>
          <el-table-column prop="startTime" label="考试开始时间"/>
          <el-table-column prop="endTime" label="考试结束时间"/>
          <el-table-column prop="useDuration" label="考试用时"/>
        </el-table>

      </div>
    </el-dialog>

    <!-- 录入成绩 -->
    <el-dialog title="录入成绩" :visible.sync="lrcjShow" width="30%" :close-on-click-modal="false" @click="lrcjItem = {}; lrcjShow = false;">
      <el-form label-width="60px" :model="lrcjItem" ref="lrcjItem">
        <el-form-item label="分数" prop="kscj">
          <el-input size="small" v-model="lrcjItem.kscj" placeholder="请输入分数" @input="formatInportData($event,'3,1','kscj',lrcjItem,0,100)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="lrcjItem = {}; lrcjShow = false;">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('lrcjItem')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryStudentList,
  queryTestListById,
  queryPaper,
  updateKscj,
} from '../../api/student'
import {timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";
import {changeClassList, savaClass, updateClass} from "../../api/classInfo";
import {selectAreaTree} from "../../api/subjectTree";

export default {
  data() {
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,
      // 录入成绩
      lrcjShow: false,
      lrcjItem: {},

      // 模拟情况
      scoreShow: false,
      scoreList: '',

      paperShow: false,
      paperList: [],

      ids: [],    // 多选框ids
      classIds: [],

      treeArr: [],  // 默认展示第二级树节点
      treeOptions: undefined,
      lxList: [
        { dictLabel: '机构客户', dictValue: '1' },
        { dictLabel: '渠道客户', dictValue: '2' },
      ],

      // 查询折叠
      activeCollapseNames: [],
      dateValue: [],
      loading: false, //是显示加载
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      lx: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    /*if (this.systemFlag == 1) {
      this.$set(this.queryParams, 'lx', '1');
    }*/
    this.getdata();
    this.selectAreaTree();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    titleFocus() {
      this.collClick = this.$refs.coll.setActiveNames
      this.$refs.coll.setActiveNames = () => {}
    },
    titleBlur() {
      this.$refs.coll.setActiveNames = this.collClick
    },
    formatInportData(value,format,field,Obj,min,max) {
      const formatArr = format.split(",");
      let regx2 = '';
      if (formatArr.length == 1) { // 说明当前校验的是整数
        // value = value.replace(/[^\d]/g,'');
        regx2=new RegExp(`^\\d{0,${formatArr[0]}}`);
      } else { // 小数
        regx2=new RegExp(`^\\d{0,${formatArr[0]}}(?:\\.\\d{0,${formatArr[1]}})?`);
        // value = value.toString().match(/^\d{0,8}(?:\.\d{0,4})?/);
      }
      value = value.toString().match(regx2);
      value = value[0];
      if (value < min) {
        Obj[field] = 0;
      } else if (value > max) {
        Obj[field] = 100;
      } else {
        Obj[field] =  value;
      }
      // 如果 数据不刷新，使用 set方法，目前使用没遇到问题
      // Vue.set([Obj],field,value)// 不能直接使用 this.$set
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },

    // 录入成绩
    handleScores(index, row) {
      this.lrcjItem = JSON.parse(JSON.stringify(row));
      this.lrcjShow = true;
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          if (this.lrcjItem.kscj == '' || this.lrcjItem.kscj == null || this.lrcjItem.kscj == undefined) {
            this.$message.error('分数不可为空');
            return;
          }

          var params = {
            id: this.lrcjItem.id,
            kscj: this.lrcjItem.kscj,
            kscjId: this.lrcjItem.kscjId,
            lx: this.lrcjItem.lx
          }

          updateKscj(params).then(res => {
            this.lrcjShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.lrcjItem = {}
              this.$message({
                type: 'success',
                message: '保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.lrcjShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 打开模拟情况 弹窗
    openAvgScore(item) {
      queryTestListById(item.id).then(res => {
        if (res.code == 200) {
          this.scoreList = res.data;
          this.scoreShow = true;
        }
      })
    },

    openPaper(item) {
      queryPaper(JSON.stringify({userId: item.userId, paperName: item.paperName})).then(res => {
        if (res.code == 200) {
          this.paperList = res.data;
          this.paperShow = true;
        }
      })
    },

    // 控制复选框
    selected(row, index) {
      return row.isDel == 1;
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryStudentList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content;
          this.lx = res.data.lx;
          // 分页赋值
          this.pageparm = res.data.pageparm
          this.pageparm.pageSize = 10;

        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      if (this.dateValue.length > 0) {
        this.queryParams.startTime = timestampToTime(this.dateValue[0]).split(' ')[0];
        this.queryParams.endTime = timestampToTime(this.dateValue[1]).split(' ')[0];
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.getdata()
    },

    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = JSON.parse(JSON.stringify(val));
    },

    selectable(row) {
      if (this.classIds.length > 0) {
        if (this.classIds[0].id == row.id) {
          return true
        } else {
          return false
        }
      } else {
        return true;
      }
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/views/system/student.vue